import type { FormRule } from 'antd';
import type { ITransportFormFields } from 'components/transport/transport-form/types';

export const validationRule: Record<keyof ITransportFormFields, FormRule[]> = {
  plateNumber: [{ required: true, type: 'string' }],
  subcontractor: [{ required: false, type: 'object' }],
  type: [{ required: true, type: 'string' }],
  subType: [{ required: true, type: 'string' }],
  maxLDM: [{ required: false, type: 'number', min: 1 }],
  maxVolume: [{ required: false, type: 'integer', min: 1 }],
  maxWeight: [{ required: false, type: 'integer', min: 1 }],
  needService: [{ required: false, type: 'boolean' }],
  inService: [{ required: false, type: 'boolean' }],
  notUsed: [{ required: false, type: 'boolean' }],
  serviceComment: [{ required: false, type: 'string' }],
  defaultCostPerKm: [],
};
